import {
    createRouter,
    createWebHistory,
    type NavigationGuardWithThis,
    type RouteRecordRaw
} from 'vue-router'
import {
    DashboardView,
    InboxView,
    PasswortAendernView,
    LoginView,
    RegisterView,
    PasswortZuruecksetzenView,
    SettingsView,
    NutzerEmailConfirm
} from '@/pages'

declare module 'vue-router' {
    interface RouteMeta {
        skipAuth?: boolean
    }
}

const checkAdminGuard: NavigationGuardWithThis<undefined> = () => {
    const authStore = useAuthStore() as any
    if (authStore.hasRole && authStore.hasRole('hoop')) {
        return true
    }
    return { name: 'dashboard' }
}

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'dashboard',
        component: DashboardView // component-key is not allowed in type
    },
    // {
    //     path: '/passwort-aenderung-beantragen',
    //     name: 'requestPasswordChange',
    //     component: PasswortAenderungBeantragenView
    // },
    // Public
    {
        path: '/anmelden',
        name: 'login',
        component: LoginView,
        meta: { skipAuth: true }
    },
    {
        path: '/passwort-zuruecksetzen',
        name: 'passwordReset',
        component: PasswortZuruecksetzenView,
        meta: { skipAuth: true }
    },
    {
        path: '/passwort-aendern/:nutzerId/:confirmationToken',
        name: 'changePassword',
        component: PasswortAendernView,
        props: true,
        meta: { skipAuth: true }
    },
    {
        path: '/email-bestaetigen/:id/:confirmationToken',
        name: 'emailBestaetigen',
        component: NutzerEmailConfirm,
        props: true,
        meta: { skipAuth: true }
    },
    {
        path: '/registrieren',
        name: 'register',
        component: RegisterView,
        props: true,
        meta: { skipAuth: true }
    },
    {
        path: '/abmeldung',
        name: 'logout',
        component: () => import('@/pages/LogoutView.vue'),
        meta: { requiresAuth: true },
        beforeEnter: async () => {
            const authStore = useAuthStore()
            await authStore.logout()
            return { name: 'login' }
        }
    },
    {
        path: '/einstellungen',
        name: 'settings',
        component: SettingsView,
        meta: { requiresAuth: true }
    },
    {
        path: '/verlauf',
        name: 'inbox',
        component: InboxView,
        meta: { requiresAuth: true }
    },
    { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: 'active',
    routes
})

router.beforeEach(async (to) => {
    const { isAuthenticated, currentUser, logout, fetchCurrentUser } = useAuthStore()

    if (isAuthenticated && !currentUser) {
        try {
            await fetchCurrentUser()
        } catch (e: unknown) {
            console.error(e)
            return logout()
        }
    }

    if (to.meta.skipAuth) {
        return true
    }

    if (!isAuthenticated) {
        return { name: 'login' }
    }
})

export { routes }

export default router
